import { ref, computed } from 'vue-demi';
import CONSTANTS from '../constants';
import { uniq } from 'lodash-es';
const {
    common: {
        request: { bindCommonApi }
    }
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('web-community-discussion-list');

export default function useRenderFeedList(props) {
    const discussionInfo = ref(null);
    const discussionFeedList = ref(null);

    const isCustomFeedId = computed(() => {
        return CONSTANTS.isCustomFeedListType(props.orderType);
    });

    async function getDiscussionInfo() {
        if (+props.discussionId !== 0) {
            const res = await commonApiRequest.get(
                'getDiscussionInfo',
                {
                    lang: props.contentLang,
                    discussionId: props.discussionId
                },
                {
                    group: null
                }
            );
            discussionInfo.value = res;
        }
    }

    async function getDiscussionFeedList() {
        if (+props.discussionId !== 0) {
            const resArr = await commonApiRequest.get(
                'getDiscussionFeedList',
                {
                    lang: props.contentLang,
                    size: props.contentNum,
                    discussionId: props.discussionId,
                    orderType: props.orderType
                },
                {
                    group: null
                }
            );
            return resArr;
        }
    }

    async function getFeedListByFeedIds() {
        const customFeedIdList = props.customFeedList?.map((i) => Number(i.feedId)) || [];
        const reqFeedIds = uniq(customFeedIdList.filter((id) => id >= CONSTANTS.MIN_FEED_ID));
        if (!reqFeedIds.length) {
            return [];
        }
        const resArr = await commonApiRequest.get(
            'getFeedListByFeedIds',
            {
                lang: props.contentLang,
                feedIds: JSON.stringify(reqFeedIds),
                needContent: true
            },
            {
                group: null
            }
        );
        if (!resArr.feedModels || !resArr.feedModels.length) {
            return [];
        }
        return resArr.feedModels.map((item) => {
            return {
                id: item.feedComm.feedId,
                title: item.feedTitle,
                content: item.content,
                imgUrl: item.summary?.pictureItems?.[0]?.thumbPic?.url || '',
                time: item.feedComm.timestamp,
                nick: item.authorInfo.nickName,
                avator: item.authorInfo.avatorUrl,
                texts: item.summary.richTextItems.filter((text) =>
                    [CONSTANTS.FEED_TYPE.TEXT, CONSTANTS.FEED_TYPE.TEXT_LINK, CONSTANTS.FEED_TYPE.STOCK].includes(
                        Number(text.type)
                    )
                ),
                stockInfos: item.allRelatedStockInfos
            };
        });
    }
    async function getData() {
        try {
            if (isCustomFeedId.value) {
                discussionFeedList.value = await getFeedListByFeedIds();
            } else {
                await getDiscussionInfo();
                if (discussionInfo.value) {
                    discussionFeedList.value = await getDiscussionFeedList();
                }
            }
        } catch (err) {
            discussionFeedList.value = [];
        }
    }

    return {
        getData,
        discussionInfo,
        discussionFeedList,
        isCustomFeedId
    };
}
